import ons from "onsenui";
import * as React from "react";
import * as Ons from "react-onsenui";
import { isLoading, Loading } from "../Loading";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { MEDFLYT_LOGO } from "../utils/svgs_new";
import { Center } from "./Center";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

export interface ReferralCodeScreenProps {
  referredBy: string | null | Loading;
  onBackClick: () => void;
  onSubmitClick: (code: string) => void;
}

export interface ReferralCodeScreenState {
  code: string;
}

export class ReferralCodeScreen extends React.Component<
  ReferralCodeScreenProps,
  ReferralCodeScreenState
> {
  constructor(props: ReferralCodeScreenProps) {
    super(props);

    this.state = {
      code: "",
    };
  }

  handleCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newCode = event.target.value;
    this.setState((_prevState: ReferralCodeScreenState) => {
      return {
        code: newCode,
      };
    });
  }

  handleSubmitClick = () => {
    if (this.state.code.length > 3) {
      this.props.onSubmitClick(this.state.code);
    } else {
      ons.notification.alert({
        animation: "none",
        modifier: "material",
        title: translate(STRINGS.ERROR),
        message: translate(STRINGS.MUST_BE_ATLEAST_3_CHARACTERS),
        cancelable: true,
      });
    }
  };

  render() {
    return (
      <Scaffold
        title={<ScaffoldTitle label={translate(STRINGS.REFERRAL_CODE)} />}
        onClickGoBack={this.props.onBackClick}
      >
        <Center>
          {isLoading(this.props.referredBy) ? (
            <Ons.ProgressCircular indeterminate={true} />
          ) : this.props.referredBy === null ? (
            <div>
              <Center>
                <AppIcon icon={MEDFLYT_LOGO} size={32} />
              </Center>
              <div className="AgencyRequestScreen__subheader">
                <div>{translate(STRINGS.WERE_YOU_REFERRED_BY_SOMEONE)}</div>
                <div>{translate(STRINGS.INSERT_THEIR_REFERRAL_CODE_HERE)}</div>
              </div>
              <input
                className={"AgencyRequestScreen__codeInput"}
                type="text"
                placeholder="Ref code"
                maxLength={9}
                value={this.state.code}
                onChange={(e) => this.handleCodeChange(e)}
              />
              <Center>
                <AppButton className="AgencyRequestScreen__search" onClick={this.handleSubmitClick}>
                  {translate(STRINGS.REFER_ME)}
                </AppButton>
              </Center>
            </div>
          ) : (
            <div className="AgencyRequestScreen__subheader">
              {translate(STRINGS.YOUVE_BEEN_SUCCESSFULLY_REFERRED)}
              <br />
              {translate(STRINGS.YOU_USED_THE_CODE)}: {this.props.referredBy}
            </div>
          )}
        </Center>
      </Scaffold>
    );
  }
}
